import { Controller } from "@hotwired/stimulus"
import SimpleBar from "simplebar"
import Waves from "node-waves"

// Câblage du layout d'administration Skote (layouts/application), repris de
// kopilot : effet d'onde sur .waves-effect, barres de défilement sur
// [data-simplebar], et bouton de la barre du haut qui replie le menu latéral.
export default class extends Controller {
  connect() {
    Waves.init()
    this.element.querySelectorAll("[data-simplebar]").forEach((el) => {
      if (!SimpleBar.instances.get(el)) new SimpleBar(el)
    })
  }

  // Grand écran : menu réduit aux icônes. Sous 992px : le menu glisse.
  toggleMenu(event) {
    event.preventDefault()
    document.body.classList.toggle("sidebar-enable")
    if (window.innerWidth >= 992) {
      document.body.classList.toggle("vertical-collpsed")
    } else {
      document.body.classList.remove("vertical-collpsed")
    }
  }
}
